@let requirePaymentMethod = requirePaymentMethod$ | async;

<div class="assign-dialog-container">
  <h1
    translate="SHARED.PADDLE_NUMBER.ASSIGN_DIALOG.TITLE"
    [translateParams]="{ paddleNumber: pledge.paddle_number }"
  ></h1>

  <div class="select-guest-container">
    <gb-profile-select
      [formControl]="userControl"
      (selectedOptionChanged)="onSelectUser($event)"
      (selectedOptionClear)="onClear()"
    ></gb-profile-select>
    @if (userControl.value && userControl.value.paddle_number) {
      <mat-error>
        {{
          'SHARED.PADDLE_NUMBER.ASSIGN_DIALOG.ALREADY_PADDLE_NUMBER'
            | translate: { paddleNumber: userControl.value.paddle_number }
        }}
      </mat-error>
    } @else {
      @if (showErrorMessage(!!requirePaymentMethod)) {
        <mat-error [translate]="errorString(!!(requirePaymentMethod$ | async))"> </mat-error>
      }
    }
  </div>

  <div class="actions-container">
    <button mat-stroked-button [mat-dialog-close]="false">
      {{ 'SHARED.PADDLE_NUMBER.ASSIGN_DIALOG.CANCEL' | translate }}
    </button>
    <button (click)="updateGuest(!!requirePaymentMethod)" [loaded]="updateUserLoaded$ | async" mat-flat-button>
      {{ 'SHARED.PADDLE_NUMBER.ASSIGN_DIALOG.ASSIGN' | translate }}
    </button>
  </div>
</div>
